export default {
  title: 'Plătește cu Pix',
  hint: 'Copiază codul și inserează-l în Pix din aplicația băncii tale, sau scanează codul QR cu aceasta.',
  copy: 'Copiază codul Pix',
  copied: 'Cod copiat',
  qr_alt: 'Cod QR Pix',
  expires_in: 'Codul expiră în {{time}}',
  waiting: 'Vom confirma comanda ta imediat ce banca ta trimite plata.',
  open_page: 'Deschide pagina de plată în schimb',
  expired: 'Acest cod Pix a expirat. Reia plata pentru a obține unul nou.',
  cancel: 'Anulează plata',
  checking: 'Se verifică plata…',
  close: 'Închide',
};
